import React, {Fragment} from "react";
import PropTypes from "prop-types";
import SafeHtmlContainer from "../../../helpers/SafeHtmlContainer";
import i18n from "../../../i18n";
import {BookizonAppManager} from "../../../index";

export class EcommerceProductDescriptionView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    canShowDescription = _ => {
        return !!this.props.productData.descrizione ||
            !!this.props.productData.descrizione_tecnica ||
            !!this.props.productData.scheda_tecnica_url ||
            !!this.props.productData.descrizione_spedizione ||
            !!this.props.productData.marca ||
            !!this.props.productData.caratteristiche?.length;
    }

    /**
     * Apre la scheda tecnica del prodotto nel browser in app.
     * @param {React.MouseEvent} event Evento del link.
     * @returns {void}
     */
    handleOpenTechnicalSheet = event => {
        event.preventDefault();
        BookizonAppManager.openInAppBrowser(this.props.productData.scheda_tecnica_url);
    }

    render() {
        return (
            <Fragment>
                {
                    this.canShowDescription() &&
                    <div className={"my-3"}>

                        {
                            !!this.props.productData.descrizione &&
                            <div className={"bg-main-z2 shadow-sm p-3 my-3 rounded"}>
                                <div className={"font-weight-bold text-on-bg-main"}>{i18n.t('ecommerce.description-headline')}</div>
                                <hr/>
                                <span className={"text-on-bg-main"}>
                                    <SafeHtmlContainer html={this.props.productData.descrizione}/>
                                </span>
                            </div>
                        }
                        {
                            !!this.props.productData.caratteristiche?.length &&
                            <div className={"bg-main-z2 shadow-sm p-3 my-3 rounded"}>
                                <div className={"font-weight-bold text-on-bg-main"}>{i18n.t('ecommerce.properties-headline')}</div>
                                <hr/>
                                <ul>
                                    {
                                        this.props.productData.caratteristiche.map(c =>
                                            <li><SafeHtmlContainer html={c}/></li>
                                        )
                                    }
                                </ul>
                            </div>
                        }
                        {
                            (!!this.props.productData.descrizione_tecnica || !!this.props.productData.scheda_tecnica_url) &&
                            <div className={"bg-main-z2 shadow-sm p-3 my-3 rounded"}>
                                <div className={"font-weight-bold text-on-bg-main"}>{i18n.t('ecommerce.technical-description-headline')}</div>
                                <hr/>
                                {
                                    !!this.props.productData.descrizione_tecnica &&
                                    <SafeHtmlContainer html={this.props.productData.descrizione_tecnica}/>
                                }
                                {
                                    !!this.props.productData.scheda_tecnica_url &&
                                    <a href={this.props.productData.scheda_tecnica_url}
                                       className={"d-block mt-3"} onClick={this.handleOpenTechnicalSheet}>
                                        {i18n.t('ecommerce.technical-sheet')}
                                    </a>
                                }
                            </div>
                        }
                        {
                            !!this.props.productData.descrizione_spedizione &&
                            <div className={"bg-main-z2 shadow-sm p-3 my-3 rounded"}>
                                <div className={"font-weight-bold text-on-bg-main"}>{i18n.t('ecommerce.shipping-description-headline')}</div>
                                <hr/>
                                <SafeHtmlContainer html={this.props.productData.descrizione_spedizione}/>
                            </div>
                        }

                    </div>
                }
            </Fragment>
        )
    }

}

EcommerceProductDescriptionView.propTypes = {
    productData: PropTypes.object.isRequired
}